import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { ModalWindowComponent } from '../components/modal-window/modal-window.component';
import { User } from '../models/user';
import { AuthorsListComponent } from '../components/authors-list/authors-list.component';
import { RoleComponent } from '../components/role/role.component';
import { RightsTemplateComponent } from '../components/rights-template/rights-template.component';
import { UserService } from '../shared/user/user-service.service';

@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.css']
})
export class UserAddComponent implements OnInit {
  @ViewChild(AuthorsListComponent)
  private authorsListComponent: AuthorsListComponent;

  @ViewChild(RoleComponent)
  private roleComponent: RoleComponent;
  @ViewChild(RightsTemplateComponent)
  private rightsTemplateComponent: RightsTemplateComponent;

  user: User = { id: 0,
  userName: '',
  userPassword: '',
  name: '',
  isActive: true,
  createDate: new Date,
  email: '' };

  isLoading = false;
  color = 'primary';
  mode = 'indeterminate';

  constructor(public dialogRef: MatDialogRef<ModalWindowComponent>, private userService: UserService, public snackBar: MatSnackBar) { }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  save(): void {

    this.isLoading = true;
    if (this.roleComponent.selectedValue !== undefined && this.rightsTemplateComponent.selectedValue.value !== null) {
    // tslint:disable-next-line:max-line-length
      this.userService.save(this.user, this.roleComponent.selectedValue, this.rightsTemplateComponent.selectedValue.value, this.authorsListComponent.selectedValue ).subscribe(
        success => {
          this.isLoading = false;
            console.log('success add user:');
            console.log(success);
            this.openSnackBar(success.toString(), '');
            this.dialogRef.close();
          }
        );
    } else {
      this.openSnackBar2('Nie można zapisać użytkownika - rola lub uprawnienia są obowiązkowe.', '');
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'top',
    });
  }

  openSnackBar2(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
      verticalPosition: 'top'
    });
  }
}
